import React, { useState } from 'react';
import styled from 'styled-components';

// ============================================
// STYLED COMPONENTS
// ============================================

const PageContainer = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  background: linear-gradient(135deg, #0c1222 0%, #1a2332 50%, #0c1222 100%);
`;

const Header = styled.div`
  padding: 20px 30px;
  background: rgba(30, 40, 60, 0.8);
  border-bottom: 1px solid rgba(100, 150, 200, 0.2);
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

const Title = styled.h1`
  color: #fff;
  font-size: 24px;
  font-weight: 600;
  margin: 0;
  display: flex;
  align-items: center;
  gap: 12px;
  
  span.badge {
    background: linear-gradient(135deg, #06b6d4 0%, #0891b2 100%);
    padding: 4px 12px;
    border-radius: 20px;
    font-size: 12px;
    font-weight: 500;
  }
`;

const ContentArea = styled.div`
  flex: 1;
  display: flex;
  overflow: hidden;
`;

const FormPanel = styled.div`
  width: 50%;
  padding: 30px;
  overflow-y: auto;
  border-right: 1px solid rgba(100, 150, 200, 0.2);
`;

const PreviewPanel = styled.div`
  width: 50%;
  padding: 30px;
  overflow-y: auto;
  background: rgba(20, 30, 45, 0.5);
`;

const Section = styled.div`
  margin-bottom: 32px;
`;

const SectionTitle = styled.h2`
  color: #fff;
  font-size: 18px;
  margin: 0 0 20px 0;
  display: flex;
  align-items: center;
  gap: 10px;
  padding-bottom: 12px;
  border-bottom: 1px solid rgba(100, 150, 200, 0.2);
`;

const StepCard = styled.div`
  background: rgba(30, 40, 60, 0.8);
  border: 1px solid rgba(100, 150, 200, 0.2);
  border-radius: 12px;
  padding: 20px;
  margin-bottom: 16px;
  position: relative;
  
  &:hover {
    border-color: rgba(100, 150, 200, 0.4);
  }
`;

const StepNumber = styled.div`
  position: absolute;
  top: -10px;
  left: 16px;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: #fff;
  width: 24px;
  height: 24px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 12px;
  font-weight: 600;
`;

const FormGroup = styled.div`
  margin-bottom: 16px;
`;

const Label = styled.label`
  display: block;
  color: rgba(255, 255, 255, 0.8);
  font-size: 13px;
  margin-bottom: 8px;
  font-weight: 500;
`;

const Input = styled.input`
  width: 100%;
  background: rgba(0, 0, 0, 0.3);
  border: 1px solid rgba(100, 150, 200, 0.3);
  border-radius: 8px;
  padding: 12px 16px;
  color: #fff;
  font-size: 14px;
  transition: all 0.2s ease;
  
  &::placeholder {
    color: rgba(255, 255, 255, 0.4);
  }
  
  &:focus {
    outline: none;
    border-color: #667eea;
    box-shadow: 0 0 0 3px rgba(102, 126, 234, 0.2);
  }
`;

const Select = styled.select`
  width: 100%;
  background: rgba(0, 0, 0, 0.3);
  border: 1px solid rgba(100, 150, 200, 0.3);
  border-radius: 8px;
  padding: 12px 16px;
  color: #fff;
  font-size: 14px;
  cursor: pointer;
  
  &:focus {
    outline: none;
    border-color: #667eea;
  }
  
  option {
    background: #1a2332;
  }
`;

const TextArea = styled.textarea`
  width: 100%;
  background: rgba(0, 0, 0, 0.3);
  border: 1px solid rgba(100, 150, 200, 0.3);
  border-radius: 8px;
  padding: 12px 16px;
  color: #fff;
  font-size: 14px;
  min-height: 100px;
  resize: vertical;
  
  &::placeholder {
    color: rgba(255, 255, 255, 0.4);
  }
  
  &:focus {
    outline: none;
    border-color: #667eea;
  }
`;

const BranchContainer = styled.div`
  margin-top: 16px;
  padding: 16px;
  background: rgba(0, 0, 0, 0.2);
  border-radius: 8px;
  border-left: 3px solid ${props => props.type === 'yes' ? '#10b981' : '#ef4444'};
`;

const BranchLabel = styled.div`
  color: ${props => props.type === 'yes' ? '#10b981' : '#ef4444'};
  font-size: 12px;
  font-weight: 600;
  text-transform: uppercase;
  margin-bottom: 12px;
`;

const AddButton = styled.button`
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  border: none;
  color: #fff;
  padding: 12px 24px;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 8px;
  transition: all 0.2s ease;
  
  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 6px 20px rgba(102, 126, 234, 0.4);
  }
`;

const DeleteButton = styled.button`
  position: absolute;
  top: 12px;
  right: 12px;
  background: rgba(239, 68, 68, 0.2);
  border: 1px solid rgba(239, 68, 68, 0.3);
  color: #ef4444;
  width: 28px;
  height: 28px;
  border-radius: 6px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 16px;
  
  &:hover {
    background: rgba(239, 68, 68, 0.3);
  }
`;

// Preview styled components
const FlowPreview = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0;
`;

const PreviewNode = styled.div`
  background: ${props => props.color || 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)'};
  padding: 16px 24px;
  border-radius: 12px;
  color: #fff;
  text-align: center;
  min-width: 200px;
  max-width: 300px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.3);
`;

const PreviewNodeTitle = styled.div`
  font-weight: 600;
  font-size: 14px;
  margin-bottom: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
`;

const PreviewNodeSubtext = styled.div`
  font-size: 12px;
  opacity: 0.8;
`;

const Connector = styled.div`
  width: 2px;
  height: 30px;
  background: rgba(100, 150, 200, 0.4);
  position: relative;
  
  &::after {
    content: '';
    position: absolute;
    bottom: -6px;
    left: -4px;
    border-left: 5px solid transparent;
    border-right: 5px solid transparent;
    border-top: 6px solid rgba(100, 150, 200, 0.4);
  }
`;

const BranchSplit = styled.div`
  display: flex;
  gap: 40px;
  position: relative;
  
  &::before {
    content: '';
    position: absolute;
    top: -15px;
    left: 50%;
    transform: translateX(-50%);
    width: calc(100% - 100px);
    height: 2px;
    background: rgba(100, 150, 200, 0.4);
  }
`;

const BranchColumn = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0;
`;

const BranchConnector = styled.div`
  width: 2px;
  height: 15px;
  background: ${props => props.type === 'yes' ? '#10b981' : '#ef4444'};
`;

const BranchTag = styled.div`
  background: ${props => props.type === 'yes' ? 'rgba(16, 185, 129, 0.2)' : 'rgba(239, 68, 68, 0.2)'};
  color: ${props => props.type === 'yes' ? '#10b981' : '#ef4444'};
  padding: 4px 12px;
  border-radius: 20px;
  font-size: 11px;
  font-weight: 600;
  margin-bottom: 8px;
`;

const PreviewTitle = styled.h2`
  color: #fff;
  font-size: 18px;
  margin: 0 0 24px 0;
  display: flex;
  align-items: center;
  gap: 10px;
`;

// ============================================
// INITIAL DATA
// ============================================

const initialSteps = [
  {
    id: '1',
    type: 'trigger',
    data: { name: 'Work Permit Request', description: 'Client requests work permit assistance' }
  },
  {
    id: '2',
    type: 'question',
    data: { 
      question: 'Have you worked in Canada before?',
      variable: 'worked_in_canada',
      yesAction: { type: 'continue' },
      noAction: { type: 'outcome', outcome: 'Check education credentials' }
    }
  },
  {
    id: '3',
    type: 'question',
    data: { 
      question: 'What type of work did you do?',
      variable: 'job_type',
      yesAction: { type: 'continue' },
      noAction: { type: 'continue' }
    }
  },
  {
    id: '4',
    type: 'condition',
    data: {
      condition: 'If job is waiter/officiant (problematic for work permit)',
      variable: 'job_type',
      yesAction: { type: 'document', document: 'salary_page' },
      noAction: { type: 'outcome', outcome: 'Eligible - Good job type' }
    }
  },
  {
    id: '5',
    type: 'aiAnalysis',
    data: {
      description: 'AI checks if salary page mentions "officiant"',
      document: 'salary_page',
      yesAction: { type: 'outcome', outcome: 'Ineligible - Job title confirmed' },
      noAction: { type: 'outcome', outcome: 'Eligible as Kitchen Worker' }
    }
  }
];

// ============================================
// MAIN COMPONENT
// ============================================

const FlowBuilderForms = () => {
  const [steps, setSteps] = useState(initialSteps);
  const [scenarioName, setScenarioName] = useState('Work Permit Eligibility Check');

  const updateStep = (stepId, field, value) => {
    setSteps(prev => prev.map(step => {
      if (step.id === stepId) {
        return {
          ...step,
          data: { ...step.data, [field]: value }
        };
      }
      return step;
    }));
  };

  const addStep = (type) => {
    const newStep = {
      id: Date.now().toString(),
      type,
      data: getDefaultStepData(type)
    };
    setSteps(prev => [...prev, newStep]);
  };

  const deleteStep = (stepId) => {
    setSteps(prev => prev.filter(s => s.id !== stepId));
  };

  const getDefaultStepData = (type) => {
    switch (type) {
      case 'trigger':
        return { name: 'New Scenario', description: '' };
      case 'question':
        return { question: '', variable: '', yesAction: { type: 'continue' }, noAction: { type: 'continue' } };
      case 'condition':
        return { condition: '', variable: '', yesAction: { type: 'continue' }, noAction: { type: 'continue' } };
      case 'aiAnalysis':
        return { description: '', document: '', yesAction: { type: 'continue' }, noAction: { type: 'continue' } };
      default:
        return {};
    }
  };

  const getStepIcon = (type) => {
    switch (type) {
      case 'trigger': return '🚀';
      case 'question': return '❓';
      case 'condition': return '⚡';
      case 'aiAnalysis': return '🤖';
      default: return '📋';
    }
  };

  const getStepColor = (type) => {
    switch (type) {
      case 'trigger': return 'linear-gradient(135deg, #22c55e 0%, #16a34a 100%)';
      case 'question': return 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)';
      case 'condition': return 'linear-gradient(135deg, #f59e0b 0%, #d97706 100%)';
      case 'aiAnalysis': return 'linear-gradient(135deg, #8b5cf6 0%, #7c3aed 100%)';
      default: return 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)';
    }
  };

  const renderStepForm = (step, index) => {
    return (
      <StepCard key={step.id}>
        <StepNumber>{index + 1}</StepNumber>
        <DeleteButton onClick={() => deleteStep(step.id)}>×</DeleteButton>
        
        {step.type === 'trigger' && (
          <>
            <FormGroup>
              <Label>🚀 Scenario Name</Label>
              <Input
                value={step.data.name}
                onChange={(e) => updateStep(step.id, 'name', e.target.value)}
                placeholder="e.g., Work Permit Eligibility"
              />
            </FormGroup>
            <FormGroup>
              <Label>Description</Label>
              <TextArea
                value={step.data.description}
                onChange={(e) => updateStep(step.id, 'description', e.target.value)}
                placeholder="When should this scenario be triggered?"
              />
            </FormGroup>
          </>
        )}

        {step.type === 'question' && (
          <>
            <FormGroup>
              <Label>❓ Question to Ask</Label>
              <Input
                value={step.data.question}
                onChange={(e) => updateStep(step.id, 'question', e.target.value)}
                placeholder="e.g., Have you worked in Canada before?"
              />
            </FormGroup>
            <FormGroup>
              <Label>Save Answer As (Variable)</Label>
              <Input
                value={step.data.variable}
                onChange={(e) => updateStep(step.id, 'variable', e.target.value)}
                placeholder="e.g., worked_in_canada"
              />
            </FormGroup>
            <BranchContainer type="yes">
              <BranchLabel type="yes">If YES:</BranchLabel>
              <Select
                value={step.data.yesAction?.type || 'continue'}
                onChange={(e) => updateStep(step.id, 'yesAction', { type: e.target.value })}
              >
                <option value="continue">Continue to next step</option>
                <option value="outcome">Set outcome</option>
                <option value="skip">Skip to step...</option>
              </Select>
            </BranchContainer>
            <BranchContainer type="no">
              <BranchLabel type="no">If NO:</BranchLabel>
              <Select
                value={step.data.noAction?.type || 'continue'}
                onChange={(e) => updateStep(step.id, 'noAction', { type: e.target.value })}
              >
                <option value="continue">Continue to next step</option>
                <option value="outcome">Set outcome</option>
                <option value="skip">Skip to step...</option>
              </Select>
            </BranchContainer>
          </>
        )}

        {step.type === 'condition' && (
          <>
            <FormGroup>
              <Label>⚡ Condition to Check</Label>
              <Input
                value={step.data.condition}
                onChange={(e) => updateStep(step.id, 'condition', e.target.value)}
                placeholder="e.g., If job is waiter/officiant"
              />
            </FormGroup>
            <BranchContainer type="yes">
              <BranchLabel type="yes">If TRUE:</BranchLabel>
              <Select
                value={step.data.yesAction?.type || 'continue'}
                onChange={(e) => updateStep(step.id, 'yesAction', { type: e.target.value })}
              >
                <option value="continue">Continue to next step</option>
                <option value="document">Request document</option>
                <option value="outcome">Set outcome</option>
              </Select>
            </BranchContainer>
            <BranchContainer type="no">
              <BranchLabel type="no">If FALSE:</BranchLabel>
              <Select
                value={step.data.noAction?.type || 'continue'}
                onChange={(e) => updateStep(step.id, 'noAction', { type: e.target.value })}
              >
                <option value="continue">Continue to next step</option>
                <option value="outcome">Set outcome</option>
              </Select>
            </BranchContainer>
          </>
        )}

        {step.type === 'aiAnalysis' && (
          <>
            <FormGroup>
              <Label>🤖 What should AI analyze?</Label>
              <TextArea
                value={step.data.description}
                onChange={(e) => updateStep(step.id, 'description', e.target.value)}
                placeholder="e.g., Check if the salary page mentions 'officiant' or similar job titles"
              />
            </FormGroup>
            <FormGroup>
              <Label>Document to Analyze</Label>
              <Select
                value={step.data.document}
                onChange={(e) => updateStep(step.id, 'document', e.target.value)}
              >
                <option value="">Select document...</option>
                <option value="salary_page">Salary Page</option>
                <option value="work_permit">Work Permit</option>
                <option value="resume">Resume</option>
                <option value="other">Other Document</option>
              </Select>
            </FormGroup>
            <BranchContainer type="yes">
              <BranchLabel type="yes">If FOUND (matches criteria):</BranchLabel>
              <Input
                placeholder="Outcome message..."
                value={step.data.yesAction?.outcome || ''}
                onChange={(e) => updateStep(step.id, 'yesAction', { type: 'outcome', outcome: e.target.value })}
              />
            </BranchContainer>
            <BranchContainer type="no">
              <BranchLabel type="no">If NOT FOUND:</BranchLabel>
              <Input
                placeholder="Outcome message..."
                value={step.data.noAction?.outcome || ''}
                onChange={(e) => updateStep(step.id, 'noAction', { type: 'outcome', outcome: e.target.value })}
              />
            </BranchContainer>
          </>
        )}
      </StepCard>
    );
  };

  const renderPreview = () => {
    return (
      <FlowPreview>
        {steps.map((step, index) => (
          <React.Fragment key={step.id}>
            <PreviewNode color={getStepColor(step.type)}>
              <PreviewNodeTitle>
                {getStepIcon(step.type)} {step.type === 'trigger' ? step.data.name : step.type.charAt(0).toUpperCase() + step.type.slice(1)}
              </PreviewNodeTitle>
              <PreviewNodeSubtext>
                {step.type === 'question' && step.data.question}
                {step.type === 'condition' && step.data.condition}
                {step.type === 'aiAnalysis' && step.data.description}
                {step.type === 'trigger' && step.data.description}
              </PreviewNodeSubtext>
            </PreviewNode>
            
            {index < steps.length - 1 && (
              <>
                <Connector />
                {(step.type === 'question' || step.type === 'condition' || step.type === 'aiAnalysis') && (
                  <BranchSplit>
                    <BranchColumn>
                      <BranchConnector type="yes" />
                      <BranchTag type="yes">YES</BranchTag>
                    </BranchColumn>
                    <BranchColumn>
                      <BranchConnector type="no" />
                      <BranchTag type="no">NO</BranchTag>
                    </BranchColumn>
                  </BranchSplit>
                )}
              </>
            )}
          </React.Fragment>
        ))}
      </FlowPreview>
    );
  };

  return (
    <PageContainer>
      <Header>
        <Title>
          📝 Scenario Form Builder
          <span className="badge">Option C: Form-Based</span>
        </Title>
      </Header>
      
      <ContentArea>
        <FormPanel>
          <Section>
            <SectionTitle>📋 Scenario Steps</SectionTitle>
            {steps.map((step, index) => renderStepForm(step, index))}
            
            <div style={{ display: 'flex', gap: '12px', flexWrap: 'wrap', marginTop: '20px' }}>
              <AddButton onClick={() => addStep('question')}>
                ❓ Add Question
              </AddButton>
              <AddButton onClick={() => addStep('condition')}>
                ⚡ Add Condition
              </AddButton>
              <AddButton onClick={() => addStep('aiAnalysis')}>
                🤖 Add AI Analysis
              </AddButton>
            </div>
          </Section>
        </FormPanel>
        
        <PreviewPanel>
          <PreviewTitle>👁️ Flow Preview</PreviewTitle>
          {renderPreview()}
        </PreviewPanel>
      </ContentArea>
    </PageContainer>
  );
};

export default FlowBuilderForms;



